"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const marketplace_to_cx_tuple_query_resolver_1 = require("./marketplace-to-cx-tuple-query-resolver");
const retail_price_format_query_resolver_1 = __importDefault(require("./retail-price-format-query-resolver"));
const points_format_query_resolver_1 = __importDefault(require("./points-format-query-resolver"));
const cx_tuple_to_i18n_domain_query_resolver_1 = __importDefault(require("./cx-tuple-to-i18n-domain-query-resolver"));
const cx_tuple_to_default_preferences_query_resolver_1 = require("./cx-tuple-to-default-preferences-query-resolver");
/**
 * Factory to manage all {@link QueryResolver} instances.
 */
class ResolverFactory {
    constructor() { }
    /**
     * Gets the QueryResolver instance that resolves the given {@link ConfigType}.
     *
     * @param configType    Indicates which configuration Type to resolve
     * @param configStage   ConfigStage to resolve the acs config
     *
     * @return Mapped {@link QueryResolver}
     *
     * @throws Error thrown if a Resolver was found, but the resolver has
     *             not been initialized
     */
    static getResolver(configType, configStage) {
        const resolverMap = (i18n_configuration_provider_1.ConfigStage.PROD === configStage) ? this.RESOLVER_MAP : this.RESOLVER_MAP_DEVO;
        if (resolverMap.has(configType)) {
            const resolver = resolverMap.get(configType);
            if (!resolver.isInitialized()) {
                this.tryInitResolver(resolver, configType);
            }
            return resolver;
        }
        else {
            throw new Error(`No resolver has been registered for config type ${configType} and config stage ${configStage}`);
        }
    }
    /**
     * Try init the non-initialized query resolver.
     *
     * @throws Error when the initialization failed after first attempt.
     */
    static tryInitResolver(resolver, configType) {
        resolver.initialize();
        if (!resolver.isInitialized()) {
            throw new Error(`Config Type ${configType} resolved to ${resolver.constructor.name}, but the resolver cannot be initialized after one attempt.`);
        }
    }
}
exports.default = ResolverFactory;
/**
 * Registers all supported Config Types and assigns the QueryResolver to use for
 * Query resolution. For derived QueryResolver (i.e Price Format) only specific
 * QueryResolvers are registered.
 */
ResolverFactory.RESOLVER_MAP = new Map([
    [i18n_configuration_provider_1.ConfigType.MARKETPLACEID_TO_CX_TUPLE, new marketplace_to_cx_tuple_query_resolver_1.MarketplaceToCxTupleQueryResolver()],
    [i18n_configuration_provider_1.ConfigType.RETAIL_PRICE_FORMAT, new retail_price_format_query_resolver_1.default()],
    [i18n_configuration_provider_1.ConfigType.POINTS_FORMAT, new points_format_query_resolver_1.default()],
    [i18n_configuration_provider_1.ConfigType.CX_TUPLE_TO_I18N_DOMAIN, new cx_tuple_to_i18n_domain_query_resolver_1.default()],
    [i18n_configuration_provider_1.ConfigType.CX_TUPLE_TO_DEFAULT_PREFERENCES, new cx_tuple_to_default_preferences_query_resolver_1.CXTupleToDefaultPreferencesQueryResolver()]
]);
/**
 * Registers all supported Config Types and assigns the QueryResolver to use for Query Resolution in Demo.
 * Right now, only the following QueryResolver support Devo.
 */
ResolverFactory.RESOLVER_MAP_DEVO = new Map([
    [i18n_configuration_provider_1.ConfigType.MARKETPLACEID_TO_CX_TUPLE, new marketplace_to_cx_tuple_query_resolver_1.MarketplaceToCxTupleQueryResolverDevo()],
    [i18n_configuration_provider_1.ConfigType.CX_TUPLE_TO_DEFAULT_PREFERENCES, new cx_tuple_to_default_preferences_query_resolver_1.CXTupleToDefaultPreferencesQueryResolverDevo()]
]);
//# sourceMappingURL=resolver-factory.js.map